import { render, staticRenderFns } from "./StudentSuperAdminPreSelect.vue?vue&type=template&id=3bc409ff"
import script from "./StudentSuperAdminPreSelect.vue?vue&type=script&lang=js"
export * from "./StudentSuperAdminPreSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports